module.exports = __webpack_public_path__ + "img/brownish.1cab767b.svg";